module.exports = __webpack_public_path__ + "img/rtap-device.e186dff9.png";